import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "reports/:reportType",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const tenantReport = require("./TenantReport").default;
          cb(null, tenantReport);
        },
        "TenantReport"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/TenantReport/index.js